import {
  useGetAllMerchantUsersQuery,
  useCreateMerchantUserMutation,
} from "../../hooks/queries/useProfileQueries";
import UserManagementContainer from "../shared/UserManagementContainer";

const Roles = () => {
  return (
    <UserManagementContainer
      showCreateButton={true}
      createButtonText="Add User"
      useUsersQuery={useGetAllMerchantUsersQuery}
      useCreateUserMutation={useCreateMerchantUserMutation}
      searchPlaceholder="Search users..."
    />
  );
};

export default Roles;
